'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_NutrientValues$() {
  $n_Lmealorama_NutrientValues$ = this;
  $m_Lmealorama_NutrientValues$();
  $m_Lmealorama_NutrientValues$();
  var kcal = 0.0;
  $m_Lmealorama_NutrientValues$();
  var protein = 0.0;
  $m_Lmealorama_NutrientValues$();
  var fat = 0.0;
  $m_Lmealorama_NutrientValues$();
  var carbs = 0.0;
  $m_Lmealorama_NutrientValues$();
  var fiber = 0.0;
  $m_Lmealorama_NutrientValues$();
}
export { $c_Lmealorama_NutrientValues$ as $c_Lmealorama_NutrientValues$ };
$p = $c_Lmealorama_NutrientValues$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_NutrientValues$;
/** @constructor */
function $h_Lmealorama_NutrientValues$() {
}
export { $h_Lmealorama_NutrientValues$ as $h_Lmealorama_NutrientValues$ };
$h_Lmealorama_NutrientValues$.prototype = $p;
$p.aSn = (function(x$0) {
  return new $c_Lmealorama_NutrientValues((+x$0.g(0)), (+x$0.g(1)), (+x$0.g(2)), (+x$0.g(3)), (+x$0.g(4)), (+x$0.g(5)));
});
var $d_Lmealorama_NutrientValues$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_NutrientValues$, "mealorama.NutrientValues$", ({
  GE: 1,
  d: 1,
  e: 1
}));
export { $d_Lmealorama_NutrientValues$ as $d_Lmealorama_NutrientValues$ };
var $n_Lmealorama_NutrientValues$;
function $m_Lmealorama_NutrientValues$() {
  if ((!$n_Lmealorama_NutrientValues$)) {
    $n_Lmealorama_NutrientValues$ = new $c_Lmealorama_NutrientValues$();
  }
  return $n_Lmealorama_NutrientValues$;
}
export { $m_Lmealorama_NutrientValues$ as $m_Lmealorama_NutrientValues$ };
/** @constructor */
function $c_Lmealorama_NutrientValues(kcal, protein, fat, carbs, fiber, sugar) {
  this.zb = 0.0;
  this.zc = 0.0;
  this.wC = 0.0;
  this.wB = 0.0;
  this.wD = 0.0;
  this.zd = 0.0;
  this.zb = kcal;
  this.zc = protein;
  this.wC = fat;
  this.wB = carbs;
  this.wD = fiber;
  this.zd = sugar;
}
export { $c_Lmealorama_NutrientValues as $c_Lmealorama_NutrientValues };
$p = $c_Lmealorama_NutrientValues.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_NutrientValues;
/** @constructor */
function $h_Lmealorama_NutrientValues() {
}
export { $h_Lmealorama_NutrientValues as $h_Lmealorama_NutrientValues };
$h_Lmealorama_NutrientValues.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, (-2109092855));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().pm(this.zb));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().pm(this.zc));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().pm(this.wC));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().pm(this.wB));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().pm(this.wD));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().pm(this.zd));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 6);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lmealorama_NutrientValues) && ((((((this.zb === x$0.zb) && (this.zc === x$0.zc)) && (this.wC === x$0.wC)) && (this.wB === x$0.wB)) && (this.wD === x$0.wD)) && (this.zd === x$0.zd))));
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 6;
});
$p.r = (function() {
  return "NutrientValues";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.zb;
      break;
    }
    case 1: {
      return this.zc;
      break;
    }
    case 2: {
      return this.wC;
      break;
    }
    case 3: {
      return this.wB;
      break;
    }
    case 4: {
      return this.wD;
      break;
    }
    case 5: {
      return this.zd;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
$p.b18 = (function(factor) {
  $m_Lmealorama_NutrientValues$();
  return new $c_Lmealorama_NutrientValues((this.zb * factor), (this.zc * factor), (this.wC * factor), (this.wB * factor), (this.wD * factor), (this.zd * factor));
});
function $isArrayOf_Lmealorama_NutrientValues(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jJ)));
}
export { $isArrayOf_Lmealorama_NutrientValues as $isArrayOf_Lmealorama_NutrientValues };
var $d_Lmealorama_NutrientValues = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_NutrientValues, "mealorama.NutrientValues", ({
  jJ: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_NutrientValues as $d_Lmealorama_NutrientValues };
//# sourceMappingURL=mealorama.-Nutrient-Values.js.map
